module.exports = __webpack_public_path__ + "static/media/features-highimpact-gray.9673f149.png";